export enum BASE_CONTRACT {
  ROUTER_LOCAL = "0xed91007e54875ac5a0d22b85822e9864a1ce2589",
  CROSS_CHAIN_ROUTER = "0xc43aeed6fbe99bf0afbbfb0d0fc1523a8c81e0f7",
  FUND_VAULT_ADDRESS = "0x0e1bb2a458db603ec57279126e6b1362433569c5",
  CONTROLLER_ADDRESS = "0xa9a06d14e839c74001a04a47fcc4676b8fcb9ff0",
  REFERRAL_ADDRESS = "0x39a18374b0357572e23c17f3057a2b0d8ed684a5",
  STARGATE_CROSSCHAIN = "0xe7c33cb97428c258e9637b2449368f13a5b6bacc",
  USDC_ADDRESS = "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
  USDT_ADDRESS = "0xf8a0bf9cf54bb92f17374d9e9a321e6a111a51bd",
  LP_USDC = "0x1e3209ca0eea83f59da55a9d15f9596800889116",
  ALLBRIDGE = "0xc61f0f0a752e0c04f6efb0f0465a0b74a54185c4",
}
export enum ARBITRUM_CONTRACT {
  ROUTER_LOCAL = "0xd79a9eb521b871f80cd29e7223206eab74832f72",
  CROSS_CHAIN_ROUTER = "0x58b637a5c994c2e822e5d4949d1a90b1778ead5d",
  FUND_VAULT_ADDRESS = "0x0f860271ba074392e896a67a23cdb488b27e2b31",
  CONTROLLER_ADDRESS = "0x8bb42db6d86132fcc4af8fa7f10ea8c77d60bbe2",
  STARGATE_CROSSCHAIN = "0x0f92f50532c6c4d7d7d95cda3474177794f1e1e4",
  USDC_ADDRESS = "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
  USDT_ADDRESS = "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9",
  LP_USDC = "0x8ca9f25973c735b9b4532a5fb66df9f46e68a2ea",
  ALLBRIDGE = "0xea2b9090b209f0836912c6cde2192341513f5c43",
}
export enum POLYGON_CONTRACT {
  ROUTER_LOCAL = "0x8be37856993a4758e07f59cd26651942dd948310",
  CROSS_CHAIN_ROUTER = "0x2d363a4ed846fa0eaa3884c25922a6552aae96d6",
  FUND_VAULT_ADDRESS = "0xde20cfa6b44767767703569ca70505db51611d61",
  CONTROLLER_ADDRESS = "0x2007f0786633c71802ffe9cad3e98259bb0a753e",
  USDT_ADDRESS = "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
  USDC_E_ADDRESS = "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
  LP_USDC = "0x1b37b54d38421e7bdbd3d886a395a87167cb3164",
  COMPOUND = "0x6243880bbc74a966A1C123c9c61b0f67d0bbb959",
}
export enum BNB_CONTRACT {
  ROUTER_LOCAL = "0x24e76ae3ecefb2477fec63752f1060a52a116c73",
  CROSS_CHAIN_ROUTER = "0x4fb7c2e5c1021a0b77e5bf302692fb3a8d232ed4",
  FUND_VAULT_ADDRESS = "0xa8affb858d60163af4c98f0a870ee8f9e6b299b1",
  CONTROLLER_ADDRESS = "0xf7786dc4f4a278e47593653890c805d91f8c9d10",
  STARGATE_CROSSCHAIN = "0x9a48fbae7ea2fcff94bd17193a3d763501c776f5",
  USDC_ADDRESS = "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
  USDT_ADDRESS = "0x55d398326f99059fF775485246999027B3197955",
  LP_USDC = "0xa3e0688036d4c8d301f5a1e0b162fa157dfd0814",
  ALLBRIDGE = "0x0f93ea942eff599298c75e941e068badb7f131db",
}
export enum DEFAULT_ADDRESS {
  DEFAULT = "0x0000000000000000000000000000000000000000",
}
